import React, { useEffect, useState } from 'react';
const API_BASE = process.env.REACT_APP_API_URL;

export default function ProductionStatusPage() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/build-orders`)
      .then(res => res.json())
      .then(setOrders)
      .catch(() => {});
  }, []);

  const now = Date.now();
  const withRemaining = orders
    .filter(o => o.status === 'Idle' || o.status === 'In Progress')
    .map(o => ({
      ...o,
      remaining: o.dueDate ? new Date(o.dueDate).getTime() - now : null,
    }))
    .sort((a, b) => {
      if (a.remaining === null) return 1;
      if (b.remaining === null) return -1;
      return a.remaining - b.remaining;
    });

  const formatRemaining = ms => {
    if (ms == null) return 'No due date';
    const days = Math.ceil(ms / (1000 * 60 * 60 * 24));
    if (days >= 14) {
      const weeks = Math.round(days / 7);
      return `${weeks} weeks till pickup`;
    }
    return `${days} days till pickup`;
  };

  return (
    <div className="ni-page">
      <div className="ni-shell ni-shell--narrow">
        <div className="ni-panel">
          <div className="ni-section-heading" style={{ marginBottom: '1rem' }}>
            <div>
              <span className="ni-eyebrow">Production Status</span>
              <h2 className="ni-section-title">Upcoming pickups and active orders</h2>
            </div>
          </div>
          <div className="ni-table-wrap">
            <table className="ni-table">
              <thead>
                <tr>
                  <th>Order</th>
                  <th>Product</th>
                  <th>Quantity</th>
                  <th>Ready By</th>
                  <th>Time Remaining</th>
                </tr>
              </thead>
              <tbody>
                {withRemaining.map(o => (
                  <tr key={o._id}>
                    <td>{o.orderNumber}</td>
                    <td>{o.product}</td>
                    <td>{o.quantity}</td>
                    <td>{o.dueDate ? new Date(o.dueDate).toLocaleDateString() : 'N/A'}</td>
                    <td>{formatRemaining(o.remaining)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
